export default __webpack_public_path__ + "static/media/image4.731b4e61.jpg";